import type { ReactElement } from 'react';

export const Dice20 = (): ReactElement => {
    return (
        <>
            <g transform="scale(40) translate(0, -24)">
                <path d="M15.2,11,12,16.113,8.805,11Zm-5.183,5.706L6.944,11.8,3.83,16.158Zm7.235-8.353,4.7-2.819a4.978,4.978,0,0,0-1.372-1.222l-6-3.6A4.99,4.99,0,0,0,12.712.05C12.778.112,17.247,8.353,17.247,8.353ZM15.323,9,12,2.848,8.677,9Zm1.733,2.8L14,16.688l6.167-.534ZM6.753,8.353S11.222.112,11.288.05A5,5,0,0,0,9.427.713l-6,3.6A4.978,4.978,0,0,0,2.055,5.534Zm11.524,1.714s4.578,6.414,4.6,6.446A4.979,4.979,0,0,0,23,15.4V8.6a4.965,4.965,0,0,0-.165-1.267ZM13,18.781V23.9a5.015,5.015,0,0,0,1.573-.614l6-3.6a5,5,0,0,0,1.719-1.732C22.226,17.976,13,18.781,13,18.781ZM5.723,10.067,1.165,7.333A4.965,4.965,0,0,0,1,8.6v6.8a4.979,4.979,0,0,0,.127,1.113C1.145,16.481,5.723,10.067,5.723,10.067ZM11,18.8s-9.227-.825-9.292-.845a5,5,0,0,0,1.719,1.732l6,3.6A5.015,5.015,0,0,0,11,23.9Z" />
            </g>
            <title>dice 20</title>
        </>
    );
};
